import { useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import { EntityTypeEnum } from '@api/ringil-api.v2.tsx';

const useWorkflowStates = (entityType: EntityTypeEnum) => {
  const [states, setStates] = useState<string[]>([]);
  const { getAllStateForCurrentWFForCompany } = useContext(ApiContext); // LovDTO

  useEffect(() => {
    getAllStateForCurrentWFForCompany(entityType,
      d => {
        setStates(d);
      });
  }, []);

  return states;
};

export default useWorkflowStates;
